import { checkToken } from '@shared/guard/AuthGuard';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function RootRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      const hasToken = await checkToken();
      navigate(hasToken ? '/dashboard' : '/auth', { replace: true });
    };
    redirect();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-lg">Перенаправление...</div>
    </div>
  );
}
